import React, { useEffect, useState } from "react";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.secondary,
    },
}));

function TextInput(props) {
    return (
        <TextField
            label={props.label}
            defaultValue=""
            value={props.value}
            InputProps={{
                readOnly: true,
            }}
            variant="outlined"
        />
    )
}


export default function UserCentre() {
    const classes = useStyles();
    const [userAttr, setUserAttr] = useState({})

    useEffect(() => {
        setUserAttr({
            'warehouse_code': 'D003',
            'family_name': '张',
            'first_name': "三",
            'email': 'test@test.com',
            'wechat': 'wechat',
        })
    }, [])
    return (
        <div>
            <Paper className={classes.paper}>
            
                <Grid container spacing={3}>
                    <Grid item xs={2}>
                        <h3>用户中心</h3>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={2}>
                        <TextInput label='专属仓库编号' value={userAttr['warehouse_code']} />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={6} lg={2}>
                        <TextInput label='姓' value={userAttr['family_name']} />
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <TextInput label='名' value={userAttr['first_name']} />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={2}>
                        <TextInput label='邮箱' value={userAttr['email']} />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={2}>
                        <TextInput label='微信号' value={userAttr['wechat']} />
                    </Grid>
                </Grid>
            </Paper>
            
        </div>
    )
}